export default __webpack_public_path__ + "static/media/salt.a2a585b9.mp3";